<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>活动名称</p>
                <el-input
                  class="input"
                  v-model="info.title"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_div">
                <p>活动分类</p>
                <el-select
                  class="input"
                  v-model="association"
                  placeholder="请选择"
                  multiple
                  disabled
                  collapse-tags
                  @change="changeAssociation"
                >
                  <el-option
                    v-for="item in classifyOptions"
                    :key="item.id"
                    :value="item.id"
                    :label="item.title"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>活动标签</p>
                <el-input
                  class="input"
                  v-model="info.label"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_div">
                <p>活动开始时间</p>
                <el-date-picker
                  class="input"
                  v-model="startTime"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </div>
              <div class="input_div">
                <p>活动结束时间</p>
                <el-date-picker
                  class="input"
                  v-model="endTime"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </div>
              <div class="input_div">
                <p>活动报名结束时间</p>
                <el-date-picker
                  class="input"
                  v-model="enrollEndTime"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
                <div class="tips">（注释：留空为该活动不需要报名）</div>
              </div>
              <div class="input_div">
                <p>活动负责人</p>
                <el-input
                  class="input"
                  v-model="info.administrator"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_div">
                <p>活动负责人联系电话</p>
                <el-input
                  class="input"
                  type="number"
                  @keyup.native="proving(0)"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  maxlength="11"
                  placeholder="请输入"
                  v-model="info.mobile"
                ></el-input>
              </div>
              <div class="input_div">
                <p>活动负责人邮箱</p>
                <el-input
                  class="input"
                  placeholder="请输入"
                  v-model="info.email"
                ></el-input>
              </div>
              <div class="input_div">
                <p>活动负责人微信二维码</p>
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  id="uploadQrcode"
                  @change="openFolderQrcode"
                />
                <el-button size="mini" @click="openImageQrcode()"
                  >选择本地图片</el-button
                >
                <el-image class="imageDiv" :src="qrcodeUrl" fit="scale-down">
                  <div
                    slot="error"
                    class="image-slot"
                    style="position: absolute; top: 50%; left: 50%"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="input_div">
                <p>活动地点</p>
                <el-input
                  class="input"
                  v-model="info.location"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_div" v-if="isAssociationAdmin == 'N'">
                <p>是否推送到首页</p>
                <el-select
                  class="input"
                  v-model="info.is_push"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in pushOptions"
                    :key="item.en"
                    :value="item.en"
                    :label="item.cn"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>是否开放游客查看</p>
                <el-select
                  class="input"
                  v-model="info.public"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in pushOptions"
                    :key="item.en"
                    :value="item.en"
                    :label="item.cn"
                  ></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>活动封面</p>
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  id="uploadfile"
                  @change="openFolder"
                />
                <el-button size="mini" @click="openImage()"
                  >选择本地图片</el-button
                >
                <el-image class="imageDiv" :src="imageUrl" fit="scale-down">
                  <div
                    slot="error"
                    class="image-slot"
                    style="position: absolute; top: 50%; left: 50%"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>详情类型</p>
                <el-select
                  style="width: 100%"
                  v-model="info.type"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in detailsTypesOptions"
                    :key="item.en"
                    :value="item.en"
                    :label="item.cn"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_div" v-if="info.type == 'details'">
                <p>推文链接</p>
                <el-input
                  class="input"
                  v-model="info.details"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div
                class="input_div"
                v-if="info.type == 'rich_text'"
                style="width: 100%"
              >
                <p>文本编辑器</p>
                <VueUeditorWrap
                  :destroy="true"
                  v-model="info.rich_text"
                  :config="editorConfig"
                />
              </div>
            </div>
          </div>
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH, Editor_Config } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import FootLayout from "@/components/layout/footLayout";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout,
    VueUeditorWrap
  },
  data() {
    return {
      meunItem: null,
      meunTitle: "",
      headTitle: "",
      urlPath: URL_PATH,
      classifyOptions: [], //活动分类
      pushOptions: Constant.options_yesorno, //是否推送
      detailsTypesOptions: Constant.details_types_filters,
      association: [],
      startTime: null,
      endTime: null,
      enrollEndTime: null,
      imageUrl: "",
      qrcodeUrl: "",
      info: { type: "details", rich_text: "", is_push: "N" },
      editorConfig: Editor_Config,
      isAssociationAdmin: "Y"
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.infoId = this.$route.query.id;
      this.headTitle =
        this.infoId == null ? "新增校友会活动" : "编辑校友会活动";
      this.associationAdmin();
      this.getAssociationId();
    },
    // 是否是校友分会长
    associationAdmin: function() {
      this.$api
        .isAssociationAdmin({
          token: localStorage.getItem("token")
        })
        .then(({ data }) => {
          this.isAssociationAdmin = data.Data.isAssociationAdmin;
        })
        .catch(({ error }) => {});
    },
    // 获取详情
    getInfo() {
      let association_id = this.$route.query.association_id;
      if (association_id) {
        this.association.push(parseInt(association_id));
      }
      var id = this.$route.query.id;
      if (id == null) return;
      var that = this;
      this.$api
        .associationActivityInfo({
          token: localStorage.getItem("token"),
          id: id
        })
        .then(({ data }) => {
          that.info = data.Data;
          that.startTime = new Date(that.info.start_time * 1000);
          that.endTime = new Date(that.info.end_time * 1000);
          that.enrollEndTime = new Date(that.info.enroll_end_time * 1000);
          that.imageUrl = that.urlPath + that.info.thumb;
          that.qrcodeUrl = that.urlPath + that.info.wx_qr_code;
          that.info.association.forEach(ass => {
            that.association.push(ass.id);
          });
        })
        .catch(({ error }) => {});
    },
    // 获取分类
    getAssociationId: function() {
      this.$api
        .getAssociationId({
          token: localStorage.getItem("token")
        })
        .then(({ data }) => {
          this.classifyOptions = [];
          data.Data.forEach(info => {
            this.classifyOptions.push(info);
          });
          this.getInfo();
        })
        .catch(({ error }) => {});
    },
    // 新增
    addActivity: function(form) {
      this.$api
        .associationUpdateActivity(form)
        .then(({ data }) => {
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 编辑
    updateActivity: function(form) {
      form.append("id", this.info.id);
      this.$api
        .associationUpdateActivity(form)
        .then(({ data }) => {
          this.$router.back(-1);
        })
        .catch(({ error }) => {});
    },
    // 选择分类
    changeAssociation(tag) {
      if (tag.length > 1) {
        tag.forEach((id, index) => {
          if (id == 0) {
            this.association = [tag[index]];
            return;
          }
        });
      }
    },
    proving(index) {
      switch (index) {
        case 0:
          this.info.mobile = this.info.mobile.replace(/\D/g, "");
          break;
      }
    },
    // 选择图片
    openImage() {
      document.getElementById("uploadfile").click();
    },
    openFolder(e) {
      var that = this;
      var image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function(evt) {
        that.imageUrl = evt.target.result;
      };
      reader.readAsDataURL(image);
      this.info.thumb = image;
    },
    // 选择二维码
    openImageQrcode() {
      document.getElementById("uploadQrcode").click();
    },
    openFolderQrcode(e) {
      var that = this;
      var image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function(evt) {
        that.qrcodeUrl = evt.target.result;
      };
      reader.readAsDataURL(image);
      this.info.wx_qr_code = image;
    },
    // 保存
    saveEdit() {
      this.info.association_list = "";
      this.association.forEach(id => {
        this.info.association_list += id + ",";
      });
      var length = this.info.association_list.length;
      if (length > 0) {
        this.info.association_list = this.info.association_list.substring(
          0,
          length - 1
        );
      }
      if (this.startTime) {
        this.info.start_time = this.startTime.getTime() / 1000;
      }
      if (this.endTime) {
        this.info.end_time = this.endTime.getTime() / 1000;
      }
      if (this.enrollEndTime) {
        this.info.enroll_end_time = this.enrollEndTime.getTime() / 1000;
      } else {
        this.info.enroll_end_time = this.enrollEndTime;
      }
      if (
        StrUtils.isEmpty(this.info.association_list) ||
        StrUtils.isEmpty(this.info.label) ||
        StrUtils.isEmpty(this.info.title) ||
        StrUtils.isEmpty(this.info.start_time) ||
        StrUtils.isEmpty(this.info.end_time) ||
        StrUtils.isEmpty(this.info.administrator) ||
        StrUtils.isEmpty(this.info.mobile) ||
        StrUtils.isEmpty(this.info.email) ||
        StrUtils.isEmpty(this.info.wx_qr_code) ||
        StrUtils.isEmpty(this.info.location) ||
        StrUtils.isEmpty(this.info.type) ||
        StrUtils.isEmpty(this.info.thumb)
      ) {
        this.$message.error("请先完善数据");
        return;
      }
      var form = new FormData();
      form.append("type", this.info.type);
      if (this.info.type == "details") {
        if (StrUtils.isEmpty(this.info.details)) {
          this.$message.error("推文链接不能为空");
          return;
        } else {
          form.append("details", this.info.details);
        }
      }
      if (this.info.type == "rich_text") {
        if (StrUtils.isEmpty(this.info.rich_text)) {
          this.$message.error("文本编辑器不能为空");
          return;
        } else {
          form.append("rich_text", this.info.rich_text);
        }
      }
      form.append("token", localStorage.getItem("token"));
      form.append("association_list", this.info.association_list);
      form.append("label", this.info.label);
      form.append("title", this.info.title);
      form.append("start_time", this.info.start_time);
      form.append("end_time", this.info.end_time);
      form.append("enroll_end_time", this.info.enroll_end_time);
      form.append("administrator", this.info.administrator);
      form.append("mobile", this.info.mobile);
      form.append("email", this.info.email);
      form.append("wx_qr_code", this.info.wx_qr_code);
      form.append("location", this.info.location);
      form.append("image", this.info.thumb);
      form.append("public", this.info.public);
      if (this.isAssociationAdmin == "N") {
        form.append("is_push", this.info.is_push);
      }
      if (this.infoId) {
        this.updateActivity(form);
      } else {
        this.addActivity(form);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
.tips {
  font-size: 12px;
  margin-top: 12px;
  color: #595959;
}
</style>

<style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/associationActivitysAdd.vue